<template>
  <div>
    <!--头部-->
    <Header></Header>
    <!--导航栏-->
    <Nav></Nav>
    <slot></slot>
    <!--底部-->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import Nav from './components/Nav'
export default {
  name: 'Main',
  components: {
    Header,
    Footer,
    Nav
  }
}
</script>

<style scoped>

</style>
